import React, { useState } from 'react';
import { ChevronDown, Mail, Info } from 'lucide-react';

const EmailGuides = () => {
  const [openGuide, setOpenGuide] = useState(null);

  const guides = [
    {
      client: "Gmail",
      steps: [
        "1. Ouvrez Gmail et cliquez sur l'icône ⚙️ (Paramètres)",
        "2. Cliquez sur 'Voir tous les paramètres'",
        "3. Dans la section 'Signature', cliquez sur 'Créer'",
        "4. Collez la signature copiée dans l'éditeur",
        "5. Cliquez sur 'Enregistrer les modifications' en bas de page"
      ]
    },
    {
      client: "Outlook",
      steps: [
        "1. Ouvrez Outlook et cliquez sur 'Nouveau message'",
        "2. Cliquez sur 'Signature' puis 'Signatures'",
        "3. Cliquez sur 'Nouveau'",
        "4. Collez la signature copiée dans l'éditeur",
        "5. Cliquez sur 'Enregistrer'"
      ]
    },
    {
      client: "Apple Mail",
      steps: [
        "1. Ouvrez Mail et cliquez sur 'Mail' > 'Réglages'",
        "2. Allez dans l'onglet 'Signatures'",
        "3. Cliquez sur le + pour ajouter une nouvelle signature",
        "4. Collez la signature copiée dans l'éditeur",
        "5. Fermez la fenêtre pour sauvegarder"
      ]
    }
  ];

  return (
    <div className="mt-8 max-w-2xl mx-auto">
      <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-6">
        <div className="flex items-start">
          <Info className="w-5 h-5 text-blue-500 mr-2 mt-1" />
          <p className="text-sm text-blue-700">
            Pour une meilleure compatibilité, nous vous recommandons de coller la signature en tant que texte brut (Ctrl+Shift+V ou Cmd+Shift+V) dans votre client mail.
          </p>
        </div>
      </div>

      <h3 className="text-xl font-semibold mb-4 flex items-center">
        <Mail className="w-5 h-5 mr-2" />
        Guide d'installation par client mail
      </h3>

      <div className="space-y-3">
        {guides.map((guide) => (
          <div key={guide.client} className="border rounded-lg overflow-hidden">
            <button
              className="w-full px-4 py-3 bg-white flex justify-between items-center hover:bg-gray-50 transition-colors"
              onClick={() => setOpenGuide(openGuide === guide.client ? null : guide.client)}
            >
              <span className="font-medium">{guide.client}</span>
              <ChevronDown
                className={`w-5 h-5 transform transition-transform ${
                  openGuide === guide.client ? 'rotate-180' : ''
                }`}
              />
            </button>
            {openGuide === guide.client && (
              <div className="px-4 py-3 bg-gray-50 border-t">
                <ol className="list-none space-y-2">
                  {guide.steps.map((step, index) => (
                    <li key={index} className="text-sm text-gray-700">
                      {step}
                    </li>
                  ))}
                </ol>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmailGuides;